export default __webpack_public_path__ + "static/media/android.96400162.svg";